export default "__VITE_ASSET__uBCGiLdf__"